import { render, staticRenderFns } from "./AndiamoPaiListPage.vue?vue&type=template&id=a7abdfd2&scoped=true"
import script from "./AndiamoPaiListPage.vue?vue&type=script&lang=js"
export * from "./AndiamoPaiListPage.vue?vue&type=script&lang=js"
import style0 from "./AndiamoPaiListPage.vue?vue&type=style&index=0&id=a7abdfd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7abdfd2",
  null
  
)

export default component.exports